module.exports = __webpack_public_path__ + "media/images/home/screen_5-da7a16bd80faf45174091c082d7e2d62.png";